import { SetStateAction } from 'react';
import {
  businessTripCurrenciesUrl,
  businessTripEligibleOrdersUrl,
  countryDietsUrl,
  userProfileUrl,
} from 'router/url';
import { fetchWithAuthorization } from 'utils/authorizedFetch';
import { getFetch } from 'utils/fetchFunctions';
import { CountryDiet } from './../types';
import { DEFAULT_CURRENCY } from './constants';
import { CurrenciesData, EligibleTripOrder, UserData } from './types';

export const fetchPersonalData = async (
  username: string,
  setPersonalData: (value: SetStateAction<UserData | undefined>) => void,
) => {
  if (!username) {
    return null;
  }
  const personalData = await getFetch({
    url: `${userProfileUrl}/${username}/info`,
  });

  const { name, surname, personalId } = personalData;

  const { contractType } = await getFetch({
    url: `${userProfileUrl}/${username}/profile`,
  });
  setPersonalData({ name, surname, personalId, contractType });
};

export const fetchCurrencies = async (
  setCurrenciesData: (value: SetStateAction<CurrenciesData[]>) => void,
) => {
  try {
    const currencies = await getFetch({
      url: `${businessTripCurrenciesUrl}`,
    });
    setCurrenciesData(
      currencies.map((currencyName: string, id: number) => {
        return {
          value: id,
          name: currencyName,
        };
      }),
    );
  } catch {
    setCurrenciesData(DEFAULT_CURRENCY);
  }
};

export const fetchCountriesDietsList = async (
  setCountriesDiets: (value: React.SetStateAction<CountryDiet[]>) => void,
) => {
  const diets = await getFetch({
    url: `${countryDietsUrl}`,
  });
  setCountriesDiets(diets);
};

export interface EligibleTripOrdersRequest {
  accountId?: number;
  from: string;
  to: string;
}

export const fetchEligibleTripOrders = async ({
  accountId,
  from,
  to,
}: EligibleTripOrdersRequest): Promise<{
  ok: boolean;
  status: number;
  data?: EligibleTripOrder[];
}> => {
  const params = new URLSearchParams({ from, to });
  if (accountId) {
    params.set('accountId', String(accountId));
  }
  try {
    const response = await fetchWithAuthorization(
      `${businessTripEligibleOrdersUrl}?${params.toString()}`,
    );
    const text = await response.text();
    let data: EligibleTripOrder[] | undefined;
    try {
      data = text ? JSON.parse(text) : undefined;
    } catch {
      data = undefined;
    }
    return { ok: response.ok, status: response.status, data };
  } catch {
    return { ok: false, status: 0 };
  }
};
